export const DATA_GRID_DL_NS = 'components/DataGridDl';

export const i18n = {
  en: {
    noRows: 'No rows',
    cell: {
      noBmt: '(empty)',
      noBmtTooltip: 'No BMT',
    },
  },
};
